module.exports = __webpack_public_path__ + "img/sandos4uWhite.png";